import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

export const fetchAdminSessions = createAsyncThunk(
  'adminSessions/fetchAll',
  async (params, { rejectWithValue }) => {
    try {
      const res = await apiService.getSessions(params || {});
      // Handle both { data: [...] } and direct [...] response formats
      return Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

export const reviewSession = createAsyncThunk(
  'adminSessions/review',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await apiService.reviewSession(id, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

export const forceCloseSessionAdmin = createAsyncThunk(
  'adminSessions/forceClose',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await apiService.forceCloseSessionById(id, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

const adminSessionsSlice = createSlice({
  name: 'adminSessions',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminSessions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminSessions.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchAdminSessions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(reviewSession.fulfilled, (state, action) => {
        const updated = action.payload;
        state.list = state.list.map((s) => (s.id === updated.id ? updated : s));
      })
      .addCase(forceCloseSessionAdmin.fulfilled, (state, action) => {
        const updated = action.payload;
        state.list = state.list.map((s) => (s.id === updated.id ? updated : s));
      });
  },
});

export default adminSessionsSlice.reducer;

